import React, { Component } from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import { SidebarProvider } from "./context/SidebarContext";
import { ToastContainer } from "react-toast";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import FoodScientistPayment from "./pages/FoodScientistPayment";
import Inspection from "./pages/Inspection";
import LicenseHistory from "./pages/LicenseHistory";
import LicenseRenewalPayment from "./pages/LicenseRenewalPayment";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import ManageInspections from "./pages/ManageInspections";
import NewLicenseHistory from "./pages/NewLicenseHistory";
import NewPassword from "./pages/NewPassword";
import NewPremisesHistory from "./pages/NewPremisesHistory";
import NewPremisesInspection from "./pages/NewPremisesInspection";
import NewRenewalLicense from "./pages/NewRenewalLicense";
import PasswordOTP from "./pages/PasswordOTP";
import PaymentSummary from "./pages/PaymentSummary";
import Payments from "./pages/Payments";
import Portal from "./pages/Portal";
import Premises from "./pages/Premises";
import PremisesRegistrationPayment from "./pages/PremisesRegistrationPayment";
import Register from "./pages/Register";
import RegisterFoodScientistV3 from "./pages/RegisterFoodScientistV3";
import RegisterLicense from "./pages/RegisterLicense";
import RegisterPremises from "./pages/RegisterPremises";
import RegistrationInstructions from "./pages/RegistrationInstructions";
import RenewPremises from "./pages/RenewPremises";
import UserAccount from "./pages/UserAccount";
import VerifyMembership from "./pages/VerifyMembership";
import VerifyPremise from "./pages/VerifyPremise";
import VerifyPayments from "./pages/VerifyPayments";
import PasswordReset from "./pages/PasswordReset";
import PasswordResetRequest from "./pages/PasswordResetRequest";
import AccountVerification from "./pages/AccountVerification";
import LeadScientistAssignments from "./pages/LeadScientistAssignments";
import SuperadminLogin from "./pages/SuperadminLogin";
import AccountSettings from "./pages/AccountSettings";

class App extends Component {
	render() {
		return (
			<HashRouter>
				<SidebarProvider>
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/superadmin" component={SuperadminLogin} />
					<Route exact path="/register" component={Register} />
					<Route exact path="/password-reset" component={PasswordResetRequest} />
					<Route exact path="/change-password" component={PasswordReset} />
					<Route exact path="/verify-account" component={AccountVerification} />
					<Route exact path="/pending-payment" component={PaymentSummary} />
					<Redirect
						exact
						from="/register-food-scientist"
						to="/register-food-scientist-v3"
					/>
					<Route
						exact
						path="/register-food-scientist-v3"
						component={RegisterFoodScientistV3}
					/>
					<Route
						exact
						path="/registration-instructions"
						component={RegistrationInstructions}
					/>
					<Route exact path="/dashboard" component={Dashboard} />
					<Redirect
						exact
						from="/register-food-scientist"
						to="/register-food-scientist-v3"
					/>
					<Route
						exact
						path="/register-food-scientist-v3"
						component={RegisterFoodScientistV3}
					/>
					<Route
						exact
						path="/registration-instructions"
						component={RegistrationInstructions}
					/>
					<Route exact path="/register-license" component={RegisterLicense} />
					<Route exact path="/register-premises" component={RegisterPremises} />
					<Route exact path="/renew-premises" component={RenewPremises} />
					<Route exact path="/premises" component={Premises} />
					<Redirect exact from="/food-scientist" to="/register-food-scientist-v3" />
					<Route exact path="/account" component={UserAccount} />
					{/* <Route
            exact
            path="/food-scientist-record"
            component={FoodScientistRecord}
          /> */}
					<Route
						exact
						path="/food-scientist-payment"
						component={FoodScientistPayment}
					/>
					<Route
						exact
						path="/register-premises-payment"
						component={PremisesRegistrationPayment}
					/>
					<Route
						exact
						path="/license-renewal-payment"
						component={LicenseRenewalPayment}
					/>
					<Route exact path="/payments" component={Payments} />
					<Route exact path="/lead-scientist-assignments" component={LeadScientistAssignments} />
					<Route exact path="/account-settings" component={AccountSettings} />
					<Route exact path="/enter-otp" component={ChangePassword} />
					<Route exact path="/add-inspection" component={Inspection} />
					{/* <Route
						exact
						path="/manage-inspections"
						component={ManageInspections}
					/> */}
					<Route exact path="/logout" component={Logout} />
					<Route
						exact
						path="/print"
						render={() => {
							window.location.href = "print.html";
						}}
					/>
					<Route exact path="/verify-payment" component={VerifyPayments} />
					<Route exact path="/verify-otp" component={PasswordOTP} />
					<Route exact path="/portal" component={Portal} />
					<Route exact path="/verify-membership" component={VerifyMembership} />
					<Route exact path="/new-password" component={NewPassword} />
					<Route exact path="/verify-premise" component={VerifyPremise} />
					<Route exact path="/license-history" component={LicenseHistory} />
					<Route
						exact
						path="/new-license-history"
						component={NewLicenseHistory}
					/>
					<Route
						exact
						path="/new-renew-license/:licenseId"
						component={NewRenewalLicense}
					/>
					<Route
						exact
						path="/new-premises-history"
						component={NewPremisesHistory}
					/>
					<Route
						exact
						path="/new-apply-premises-inspection"
						component={NewPremisesInspection}
					/>
					<Redirect exact from="/remita" to="/payments" />
					<Redirect exact from="/" to="/login" />
				</Switch>
				</SidebarProvider>
			</HashRouter>
		);
	}
}

export default App;
